import React from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import FooterNav from "./FooterNav";

// // Validation schema with Yup
// const validationSchema = Yup.object({
//   firstName: Yup.string().required("First Name is required"),
//   lastName: Yup.string().required("Last Name is required"),
//   email: Yup.string()
//     .email("Invalid email format")
//     .required("Email is required"),
//   donationAmount: Yup.number()
//     .positive("Donation must be a positive number")
//     .required("Donation Amount is required"),
// });

const ClearCatch = () => {
  // Handle form submission
  const navigate = useNavigate();
  const handleSubmit = (values) => {
    const { donationAmount } = values;
    toast.success(
      "Cache successfully cleared! Your device is now optimized for better performance!"
    );
    setTimeout(() => {
        // Reset the form after submission
        navigate('/personalinfo')
      }, 1000);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f83600",
            marginBottom: 1,
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          {/* <Typography variant="subtitle2" color="#fff">
          Clear Catch
          </Typography> */}
          <Box> </Box>
        </Box>

        <Box
          sx={{
            padding: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
                <Typography
              variant="h4"
              color="secondary.light"
              gutterBottom
              sx={{ textAlign: "center" }}
            >
              Clear Catch
            </Typography>
          {/* Formik form */}
          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
              donationAmount: "",
            }}
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
        
            {({ values, handleChange, touched, errors }) => (
              <Form
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  height: "100px",
                  width: "80%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* Submit Button */}
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ color: "#fff" }}
                >
                  Clear catch
                </Button>
              </Form>
            )}
          </Formik>

          {/* Toast Notifications */}
          <ToastContainer />
        </Box>
      </div>
      <FooterNav />
    </>
  );
};

export default ClearCatch;
